import { render, staticRenderFns } from "./score-result-list-khmer.vue?vue&type=template&id=f9cef5f6&"
import script from "./score-result-list-khmer.vue?vue&type=script&lang=js&"
export * from "./score-result-list-khmer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports